import { Company } from "../domain/Company";
import { CompanyRepository } from "../domain/CompanyRepository";
import { query_dispatcher } from "@/api/client";

export class APICompanyRepository implements CompanyRepository {

    find_by_ids(company_ids: number[]): Promise<Company[]> {
        throw new Error("Method not implemented.");
    }

    async find_by_user_id(user_id: number): Promise<Company[]> {
        return await query_dispatcher.dispatch('get.user.companies', { user_id: user_id })
    }
}